import { useState } from 'react';
import { useApp } from '../store.js';

export function Login() {
  const setAuth = useApp((s) => s.setAuth);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, code }),
      });
      const body = await res.json();
      if (!res.ok) {
        setError(body.error ?? 'login failed');
        return;
      }
      setAuth('ready', body.username);
    } catch {
      setError('network error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={submit}>
        <h1>RBV Notes</h1>
        <input
          placeholder="Username"
          value={username}
          autoCapitalize="none"
          autoCorrect="off"
          autoComplete="username"
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          placeholder="Password"
          type="password"
          value={password}
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          placeholder="2FA code"
          value={code}
          inputMode="numeric"
          autoComplete="one-time-code"
          onChange={(e) => setCode(e.target.value)}
        />
        {error && <div className="auth-error">{error}</div>}
        <button className="primary" disabled={busy || !username || !password || !code}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
